import React from "react";
import PropTypes from "prop-types";
import Modal from "../../shared/modal";
import CarGalleryView from "../car-gallery-view";
import TrackImpression from "../../shared/track-impression";
import { showNewTestDriveVariant, showTestDriveVariant } from "../../../utils/helpers/get-ab-expirement-variant";
import CarDetailOuterImagesRevamp from "../car-detail-outer-images-revamp/";
import useUserGeoLocation from "../../../hooks/use-user-geo-location";
const CarDetailAtfVariantRevamp = ({
    content = {},
    ctaProps,
    onWishlistClick,
    order,
    isWishlisted,
    comingSoon,
    isGalleryOpen,
    onClickNotifyIcon,
    isGalleryView,
    testDriveConfig
}) => {
    const userGeoData = useUserGeoLocation();
    const isTestDriveVariant = showTestDriveVariant({ content, order });
    const { state: { name: userState = {}} = {}, country: { isoCode: countryCode } = {}} = userGeoData || {};
    const {eligibleStateNames = [], enabledForIndia: isTestDriveEnabledForIndia = false} = testDriveConfig?.data || {};
    const isNewTestDriveLocationVariant = showNewTestDriveVariant({ content, order, userState, isTestDriveEnabledForIndia, countryCode, eligibleStateNames });

    return (
        <TrackImpression event={{name: "imageGalleryViewd"}}>
            <div>
                <CarDetailOuterImagesRevamp
                    onWishlistClick={onWishlistClick}
                    isWishlisted={isWishlisted}
                    showWishListIcon={isNewTestDriveLocationVariant && !isTestDriveVariant}
                />
                <Modal isOpen={isGalleryOpen} contentClass="maxHeight">
                    <CarGalleryView
                        isGalleryView={isGalleryView}
                        onWishlistClick={onWishlistClick}
                        isWishlisted={isWishlisted}
                        ctaProps={ctaProps}
                        comingSoon={comingSoon}
                        onClickNotifyIcon={onClickNotifyIcon}
                        isMaxHeight={true}
                    />
                </Modal>
            </div>
        </TrackImpression>
    );
};

CarDetailAtfVariantRevamp.propTypes = {
    content: PropTypes.object,
    ctaProps: PropTypes.object,
    onWishlistClick: PropTypes.func,
    isGalleryView: PropTypes.func,
    onClickNotifyIcon: PropTypes.func,
    isWishlisted: PropTypes.bool,
    comingSoon: PropTypes.bool,
    isGalleryOpen: PropTypes.bool,
    showCdpGalleryVariant: PropTypes.object,
    order: PropTypes.object,
    isFetchingOrderDetails: PropTypes.bool,
    testDriveConfig: PropTypes.bool
};

export default CarDetailAtfVariantRevamp;
